import { logger } from '@/util/logger';

const SELECTOR = '[data-assurance-more-details]';
const EVENT_NAME = 'assurance:open-approver-modal';

export function registerAssuranceMoreDetailsHandler(): void {
    document.addEventListener('click', (event) => {
        const link = (event.target as Element | null)?.closest<HTMLElement>(SELECTOR);
        if (!link) return;

        event.preventDefault();

        const expPk = Number(link.dataset.expPk);
        if (!Number.isFinite(expPk)) {
            logger.warn('assurance-more-details: missing or non-numeric data-exp-pk');
            return;
        }

        const flagPkRaw = link.dataset.flagPk;
        const flagPk = flagPkRaw !== undefined ? Number(flagPkRaw) : undefined;

        // Dismiss the legacy details popup (window.showhidePopup, z-index 2001)
        // so it doesn't sit above the MUI Dialog (z-index 1300) when the modal opens.
        const hideLastPopup = (window as { hideLastPopup?: () => void }).hideLastPopup;
        if (typeof hideLastPopup === 'function') hideLastPopup();

        document.dispatchEvent(
            new CustomEvent(EVENT_NAME, {
                detail: { expPk, flagPk: Number.isFinite(flagPk) ? flagPk : undefined }
            })
        );
    });
}
